import { Nullable } from '@/models/Model';
import { formatDisplayValue } from './formatDisplayValue';
import { ComplexDateOutputValue, DiscreteDateLabels } from './types';
import { useDiscreteLabels } from './useDiscreteLabels';

export const useFormatDisplayValue = (labels?: DiscreteDateLabels) => {
  const defaultLabels = useDiscreteLabels();
  const discreteLabels = labels ?? defaultLabels;

  return (value: Nullable<ComplexDateOutputValue>) =>
    formatDisplayValue(value ?? null, discreteLabels);
};
